import { Loader, MiniTile, Row, DeltaBadge, useReport, ExportCsvButton } from "../shared";

export const RevenueBreakdownSection = ({ filter }) => {
  const [data, loading, prevData] = useReport("/reports/revenue-breakdown", filter, false);
  if (loading) return <Loader />;
  if (!data) return null;
  return (
    <div className="space-y-4" data-testid="revenue-section">
      <div className="flex justify-end">
        <ExportCsvButton path="/reports/revenue-breakdown/export.csv" filter={filter} isSingleDay={false} testId="export-revenue-csv" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <MiniTile
          label="Total Revenue"
          value={`$${data.total_revenue.toFixed(2)}`}
          valueClass="text-2xl font-mono font-semibold"
          testId="rev-total"
          extra={prevData ? <DeltaBadge current={data.total_revenue} previous={prevData.total_revenue} /> : null}
        />
        <MiniTile
          label="Cash"
          value={`$${data.cash_total.toFixed(2)}`}
          testId="rev-cash"
          extra={prevData ? <DeltaBadge current={data.cash_total} previous={prevData.cash_total} /> : null}
        />
        <MiniTile
          label="Credit"
          value={`$${data.card_total.toFixed(2)} (${data.card_transaction_count} txns)`}
          testId="rev-card"
          extra={prevData ? <DeltaBadge current={data.card_total} previous={prevData.card_total} /> : null}
        />
        <MiniTile
          label="CC Fees"
          value={`-$${data.cc_fees.toFixed(2)}`}
          tone="text-red-600"
          testId="rev-fees"
          extra={prevData ? <DeltaBadge current={data.cc_fees} previous={prevData.cc_fees} invertGood /> : null}
        />
      </div>
      <div className="rounded-lg border border-border p-4 bg-secondary/30 space-y-2 text-sm font-mono">
        <Row left="Gross card sales" right={`$${data.card_total.toFixed(2)}`} />
        <Row
          left={`Processor fees (${data.cc_fee_percent}% + $${data.cc_fee_fixed_per_txn.toFixed(2)}/txn)`}
          right={`−$${data.cc_fees.toFixed(2)}`}
          tone="text-red-600"
        />
        <Row
          left="Net card deposit"
          right={`$${data.net_card_deposit.toFixed(2)}`}
          bold
          testId="rev-net-card"
        />
        <div className="h-px bg-border my-1" />
        <Row left="Cash on hand" right={`$${data.cash_total.toFixed(2)}`} />
        <Row
          left="Net deposit total"
          right={`$${data.net_deposit_total.toFixed(2)}`}
          bold
          tone="text-accent"
          testId="rev-net-total"
        />
        {data.refunds_total > 0 && (
          <Row
            left="Refunds issued"
            right={`$${data.refunds_total.toFixed(2)}`}
            tone="text-amber-700"
          />
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        CC fee rate is configurable in Admin → Settings → Payment.
      </p>
    </div>
  );
};
